var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask-page"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/mask-page/index.vue?vue&type=template&id=4be089b7
// module id = null
// module chunks = 